import React, { useState, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import api from './axiosConfig';
import { Container, Typography, Box, Chip } from '@mui/material';
import './HolidayCalendar.css';

const HolidayCalendar = () => {
  const [events, setEvents] = useState([]);

  const fetchHolidays = async (fetchInfo) => {
    try {
      const params = {};
      if (fetchInfo) {
        params.start = fetchInfo.startStr;
        params.end = fetchInfo.endStr;
      }
      
      const response = await api.get('/time-off/calendar', { params });
      setEvents(response.data);
    } catch (error) {
      console.error('Error fetching holidays:', error);
    }
  };

  useEffect(() => {
    fetchHolidays();
  }, []);

  const handleDateClick = (arg) => {
    // Could open a "new request" dialog
  };

  const handleEventClick = (info) => {
    // Could open event details
    console.log('Event clicked:', info.event.extendedProps);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 3 }}>
      <Typography variant="h4" gutterBottom>
        Team Calendar
      </Typography>
      
      {/* Legend */}
      <Box sx={{ mb: 2, display: 'flex', gap: 2 }}>
        <Chip size="small" sx={{ bgcolor: '#16A34A', color: 'white' }} label="Approved" />
        <Chip size="small" sx={{ bgcolor: '#F59E0B', color: 'white' }} label="Pending" />
        <Chip size="small" sx={{ bgcolor: '#DC2626', color: 'white' }} label="Refused" />
      </Box>

      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        events={events}
        dateClick={handleDateClick}
        eventClick={handleEventClick}
        datesSet={fetchHolidays}
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,dayGridWeek'
        }}
      />
    </Container>
  );
};

export default HolidayCalendar;